export default __webpack_public_path__ + "images/icons/chevron-right-ghost.svg";